const partitionBy = <Item>(list: Item[], partitionBy: (t: Item) => boolean) => {
    const partitioned = list.reduce(
        ([pass, fail], element) => {
            if (partitionBy(element)) {
                pass.push(element);
            } else {
                fail.push(element);
            }
            return [pass, fail];
        },
        [[] as Item[], [] as Item[]],
    );
    return partitioned;
};

export { partitionBy };
